/* Store the customer-selected show on the Shopify cart for server validation. */
(() => {
  const CART_ATTRIBUTE = 'presale_location_id';
  let lastSyncedValue;

  function normalizeId(value) {
    if (value == null) return null;
    if (typeof value === 'object') value = value.locationId ?? value.location_id ?? value.id ?? value.value ?? null;
    const stringValue = String(value ?? '').trim();
    const gid = stringValue.match(/gid:\/\/shopify\/Location\/(\d+)/i);
    return gid ? gid[1] : (/^\d+$/.test(stringValue) ? stringValue : null);
  }

  function selectedLocationId() {
    const selectedRadio = document.querySelector('#locationNamesContainer input[type="radio"]:checked');
    if (selectedRadio) {
      const row = selectedRadio.closest('.location-radio-and-label, .location-container');
      const fromDom = [
        selectedRadio.dataset.locationId,
        selectedRadio.getAttribute('data-location-id'),
        selectedRadio.value,
        row?.dataset.locationId,
        row?.getAttribute('data-location-id'),
      ].map(normalizeId).find(Boolean);
      if (fromDom) return fromDom;
    }

    try {
      const stored = localStorage.getItem('selected_location');
      if (!stored) return null;
      try { return normalizeId(JSON.parse(stored)); } catch { return normalizeId(stored); }
    } catch {
      return null;
    }
  }

  async function syncCartContext() {
    const locationId = selectedLocationId() || '';
    if (locationId === lastSyncedValue) return;

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [CART_ATTRIBUTE]: locationId } }),
    });

    if (!response.ok) throw new Error(`Cart context update failed (${response.status})`);
    lastSyncedValue = locationId;
    document.dispatchEvent(new CustomEvent('presale:cart-context', { detail: { locationId } }));
  }

  function syncSoon() {
    window.setTimeout(() => syncCartContext().catch((error) => console.warn('[Presale Guard]', error)), 0);
  }

  document.addEventListener('locationChanged', syncSoon);
  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.matches('#locationNamesContainer input[type="radio"]')) syncSoon();
  }, true);
  document.addEventListener('shopify:section:load', syncSoon);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncSoon, { once: true });
  else syncSoon();
})();
